module.exports = __webpack_public_path__ + "img/Mono Logo(ko)_Light.204b2dff.svg";